import { Breadcrumbs } from "@/components/Breadcrumbs/Breadcrumbs";
import { BlogPostHeader } from "../BlogPostHeader/BlogPostHeader";
import {
  BillettoEventType,
  mapBillettoImageToImageType,
} from "@/getData/fetchBillettoData";
import { ParentsType } from "@/wp/getParentPages";
import { useRouter } from "next/router";
import { Headline } from "@/components/Headline/Headline";
import { MediaItemResponsive } from "@/components/MediaItem/MediaItemResponsive";
import { ContentTag } from "@/components/ContentTag/ContentTag";
import { Button } from "@/components/Button/Button";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import styles from "./EventSingleViewHeader.module.scss";
import { getFormatedDatetimeSpan } from "@/utils/datetime";

type EventSingleViewHeaderProps = {
  billettoData: BillettoEventType;
  parents: ParentsType;
};

export const EventSingleViewHeader = ({
  billettoData,
  parents,
}: EventSingleViewHeaderProps) => {
  const { locale } = useRouter();
  const { getLabel } = useGlobalContext();

  const {
    id,
    name,
    editorial: { description_html },
    starts_at,
    ends_at,
    image_url,
    public_url,
  } = billettoData;

  const eventImage = mapBillettoImageToImageType(id, name, image_url);

  const breadcrumbsJSX = (
    <div className={`nav-oriented-breadcrumbs ${styles["breadcrumb-wrapper"]}`}>
      <Breadcrumbs
        parents={parents}
        breadcrumbPositon={"is-justify-content-flex-start"}
        breadcrumbTitle={billettoData.name}
      />
    </div>
  );

  const contentJSX = (
    <>
      <span className="category-date-overline">
        {getFormatedDatetimeSpan(starts_at, ends_at, locale)}
      </span>

      <Headline
        headline={name}
        headline_html_tag="h1-posts"
        extraClass={`is-flex is-flex-direction-column ${styles["event-headline"]}`}
        disableAnimation
      />

      <MediaItemResponsive
        image_desktop={eventImage}
        sizes="(max-width: 767px) 100vw, (max-width: 1599px) 50vw, 1024px"
        className={styles["event-image"]}
        priority
      />

      <ContentTag
        content={description_html}
        extraClass={styles["event-description"]}
      />
      <Button
        type="primary"
        href={public_url}
        target="_blank"
        aria-label={getLabel("aria_label_buy_event_ticket_button")}
      >
        {getLabel("buy_event_ticket_button")}
      </Button>
    </>
  );

  return (
    <BlogPostHeader breadcrumbsJSX={breadcrumbsJSX} contentJSX={contentJSX} />
  );
};
